module.exports = __webpack_public_path__ + "static/media/PB040519.2e7db92c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/comic-con/PB040519.JPG
// module id = 195
// module chunks = 0